module.exports = __webpack_public_path__ + "static/media/trag.dd1a8026.png";